/* eslint-disable */
import fileService from '@/shared/file/file-service';
import logService from '@/shared/entity-logger';
import { db, firebase } from '@/shared/firebase/firebase-init';
import documentModel from './document-model';
import _ from 'underscore'

const KEY_DOCUMENTS = 'documents'
const NAME_ENTITY = 'club'

export default {
  list() {
    return new Promise((resolve) => {
      db.ref(KEY_DOCUMENTS).once('value').then((snapshot) => { 
        var list = []
        snapshot.forEach(childSnapshot => {
          list.push(childSnapshot.val())
        });
        
        resolve(list.reverse())
      });
    });
  },

  save(model, loggedUser) {
    if (model.id) {
      return this.update(model, loggedUser);
    }

    return this.create(model, loggedUser);
  },

  find(id) {
    return new Promise((resolve, reject) => {
      db.ref(KEY_DOCUMENTS).child(id).once('value').then((snapshot) => { 
        var model = snapshot.val();
        
        if (!model) {
          return null;
        }
        
        fileService.fillDownloadURLs(
          KEY_DOCUMENTS,
          model,
          ['attachments'],
          model.attachments
        ).then(() => {
          resolve(model)
        }).catch((error) => {
          reject(error)
        });
      })
    });
  },

  /**
   * Elimina un club, solo en el caso de que el club no tenga equipos
   * @param {*} model 
   * @param {*} loggedUser 
   */
  destroy(model, loggedUser) {
    const modelToDestroy = {
      ...model,
      modified:  firebase.database.ServerValue.TIMESTAMP,
      deleted:  firebase.database.ServerValue.TIMESTAMP,
      deletedBy:  { id: loggedUser.id, email: loggedUser.email },
      modifiedBy:  { id: loggedUser.id, email: loggedUser.email }
    };

    return new Promise((resolve, reject) => {

      var updates = {};
      updates['/' + KEY_DOCUMENTS + '/' + model.id ] = null;

      db.ref().update(updates, (error) => {
        if (error) {
          // The write failed...
          reject(error)
        } else {

          // Data deleted successfully!
          fileService.deleteAll(KEY_DOCUMENTS, model, ['attachments'], model.attachments)
          .then(() => {
            logService.log(modelToDestroy, "deleted", KEY_DOCUMENTS, NAME_ENTITY)
            resolve()
          }).catch((error) => {
            reject(error)
          });
        }
      })
      
    })
  },

  update(model, loggedUser) {
   
    const modelToUpdate = {
      ...model,
      modified:  firebase.database.ServerValue.TIMESTAMP,
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    };

    return new Promise((resolve, reject) => {
      fileService.uploadAll(KEY_DOCUMENTS, modelToUpdate, ['attachments'], modelToUpdate.attachments)
        .then(() => {
           
          var updates = {};
          updates['/' + KEY_DOCUMENTS + '/' + modelToUpdate.id ] = documentModel.forUpdate(modelToUpdate);

          db.ref().update(updates, (error) => {
            if (error) {
              // The write failed...
              reject(error)
            } else {
              // Logs
              logService.log(modelToUpdate, "modified", KEY_DOCUMENTS, NAME_ENTITY)
              resolve()
            }
          })
        }).catch((error) => {
          reject(error)
        });
      });
  },

  create(model,loggedUser) {
    const modelToSave = {
      ...model,
      id: db.ref(KEY_DOCUMENTS).push().key,
      created: firebase.database.ServerValue.TIMESTAMP,
      modified:  firebase.database.ServerValue.TIMESTAMP,
      createdBy: { id: loggedUser.id, email: loggedUser.email } ,
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    };

    return new Promise((resolve, reject) => {
      fileService.uploadAll(KEY_DOCUMENTS, modelToSave, ['attachments'], modelToSave.attachments)
      .then(() => {
        db.ref(KEY_DOCUMENTS).child(modelToSave.id).set(documentModel.forCreate(modelToSave), (error) => {
          if (error) {
            // The write failed...
            reject(error)
          } else {
            // Data saved successfully!
            logService.log(modelToSave, "created", KEY_DOCUMENTS, NAME_ENTITY)
            resolve(modelToSave)
          }
        });
      }).catch((error) => {
        reject(error)
      });
    });
  },

  listOptions() {
    return new Promise((resolve) => {
      db.ref(KEY_DOCUMENTS).once('value').then((snapshot) => { 
        const list = []
        snapshot.forEach(childSnapshot => {
          var modelOption = {}
          modelOption.id = childSnapshot.key
          modelOption.name = childSnapshot.val().name
          list.push(modelOption)
        });
        resolve(list)
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/entities/document/document-service.js